export default {
    recoveryPassword: 'Recover password',
    login: 'Log in',
    loginWithGoogle: 'Sign in with Google',
    loginWithOutlook: 'Sign in with Outlook',
    notAccount: 'Don\'t you have an account?',
    notAccountRegister: 'Register',
    requestAccount: 'Request an account',
    requestAccountMessage: 'Hi, I\'d like to request a Keru account.',
    loginError: 'An error occurred while logging in',
    resetPasswordError: 'An error occurred while resetting the password:',
    invalidCredentials: 'Invalid credentials. Please try again.',
    MF2field: 'Enter the authentication code',
    rememberMF2: 'Remember authentication code',
    validateEmail: 'Verify the email entered and try again',
    invalidEmail: 'You must enter a valid email to continue',
    nextStep: 'Next',
    changeEmail: 'Change email',
    mf2CodeRequired: 'You must enter the authentication code',
    notConfirmedAccount: 'Your account is not confirmed yet. Please check your email to confirm your account.',
    confirmAccount: 'Confirm your account',

};
